<template>
  <new-bill-form
    :initBill="initBill"
    :successMsg="t('billWasCreated')"
    :submitAction="submit"
    :enableClearForm="true"
    :clearFormOnSubmit="true"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import NewBillForm from './NewBillForm.vue'

// models
import { useI18n } from 'vue-i18n'
import VendorBill from '@/models/vendor/VendorBill'

export default defineComponent({
  components: { NewBillForm },
  name: 'new-bill',

  setup() {
    const { t } = useI18n({
      messages: {
        en: { billWasCreated: 'Bill was created successfully' },
        ar: { billWasCreated: 'تم انشاء المنتج بنجاح' } //needs to correct the translation
      }
    })
    return { t }
  },

  data() {
    const initBill = new VendorBill()
    initBill.billDate = new Date()

    return {
      initBill
    }
  },

  methods: {
    async submit(bill: VendorBill, cashierPin?: string) {
      try {
        const formData = new FormData()

        // Add bill data as JSON body
        formData.set("body", JSON.stringify(bill))

        // Add attachment files if any
        if (bill.attachmentFiles && bill.attachmentFiles.length > 0) {
          bill.attachmentFiles.forEach((file) => {
            formData.append("attachments", file)
          })
        }

        // Add PIN to headers if provided
        const headers: any = {}
        if (cashierPin) {
          headers.pin = cashierPin
        }

        await this.$http.post<VendorBill>(VendorBill.ENDPOINT, formData, { headers })
        this.$router.back();
      } catch (error) {
        return error
      }
    }
  }
})
</script>
